import { OnlineSalesUnauthenticated } from 'gw-edge-client';
import { selector } from 'recoil';
import { jobInfoAtom } from '../atoms/jobInfoAtom';
import { getOnsaCurrentProductSelector } from './getOnsaCurrentProductSelector';
import { isLoggedOnSelector } from './isLoggedOnSelector';
import type { CaravanContentSumOptionDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto';

export const caravanContentSumOptionsSelector = selector<CaravanContentSumOptionDTO[]>({
    key: 'caravanContentSumOptionsSelector',
    get: async ({ get }) => {
        const { jobNumber, sessionId } = get(jobInfoAtom);
        const currentProduct = get(getOnsaCurrentProductSelector);
        if (!currentProduct) return [];
        const { fixedId } = currentProduct;
        const isLoggedOn = get(isLoggedOnSelector);

        return await OnlineSalesUnauthenticated.getCaravanContentSumOptions(
            jobNumber,
            sessionId,
            fixedId,
            !isLoggedOn
        );
    }
});
